import React, { useEffect, useState } from "react";
import { base_url } from "Backend/api";
import Icon from "components/AppIcon";
import AppSpinner from "components/ui/AppSpinner";
import { useNavigate, useParams } from "react-router-dom";

const ReviewsPage = ({ type = "restaurant" }) => {
    const { slug } = useParams();
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const token = localStorage.getItem("token");

    const endpoint =
        type === "restaurant"
            ? `${base_url}/api/restaurants/${slug}/reviews`
            : `${base_url}/api/markets/${slug}/reviews`;

    useEffect(() => {
        fetchReviews();
    }, [slug]);

    const fetchReviews = async () => {
        try {
            const res = await fetch(endpoint, {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await res.json();

            if (data.status) {
                setReviews(data.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const filledCommentReviews = reviews.filter(
        (r) => typeof r?.comment === "string" && r.comment.trim().length > 0
    );

    // ⭐ حساب متوسط التقييم لكل ريفيو
    const getReviewAverage = (review) => {
        const values = [
            review.rating_food,
            review.rating_service,
            review.rating_delivery,
            review.rating_products,
            review.rating_prices,
        ]
            .map(Number)
            .filter((v) => v > 0);

        if (!values.length) return 0;

        return values.reduce((a, b) => a + b, 0) / values.length;
    };

    // ⭐ حساب الإحصائيات العامة
    const getStats = () => {
        const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };

        reviews.forEach((r) => {
            const avg = Math.round(getReviewAverage(r));
            if (counts[avg] !== undefined) counts[avg]++;
        });

        const total = reviews.length;

        const avg =
            reviews.reduce((sum, r) => sum + getReviewAverage(r), 0) /
            (total || 1);

        return { counts, total, avg: avg.toFixed(1) };
    };

    const stats = getStats();

    if (loading) {
    return (
        <div className="flex justify-center py-16">
            <AppSpinner />
        </div>
    );
}

    return (
        <div className="p-4 font-[cairo] bg-gray-50 min-h-screen">
            <div className="mb-3 flex items-center justify-between">
                <button
                    onClick={() => navigate(-1)}
                    className="flex h-8 w-8 items-center justify-center rounded-full text-gray-500 hover:bg-gray-200"
                    aria-label="رجوع"
                >
                    <Icon name="ChevronRight" size={20} />
                </button>
                <h1 className="text-base font-medium font-[cairo] text-gray-800">التقييمات</h1>
                <span className="w-8" />
            </div>

            {/* ⭐ التقييم العام */}
            <div className="bg-white p-4 rounded-[4px] shadow mb-4 text-center">
                <h1 className="text-4xl font-bold">{stats.avg}</h1>

                <div className="flex justify-center mt-2">
                    {[1, 2, 3, 4, 5].map((i) => (
                        <Icon
                            key={i}
                            name="Star"
                            size={20}
                            className={
                                i <= Math.round(stats.avg)
                                    ? "text-orange-500"
                                    : "text-gray-300"
                            }
                        />
                    ))}
                </div>

                <p className="text-sm text-gray-500 mt-1">
                    بناءً على {stats.total} تقييم
                </p>

                {/* ⭐ bars */}
               {[5, 4, 3, 2, 1].map((star) => {
  const percent =
    stats.total > 0
      ? (stats.counts[star] / stats.total) * 100
      : 0;

  return (
    <div key={star} className="flex items-center gap-2 mt-2">

      {/* ⭐ الرقم + النجمة */}
      <div className="flex items-center gap-1 w-8">
        <span className="text-sm">{star}</span>
        <Icon name="Star" size={12} className="text-orange-500" />
      </div>

      {/* 📊 البار */}
      <div className="flex-1 h-2 bg-gray-200 rounded">
        <div
          className="h-2 bg-orange-500 rounded"
          style={{ width: `${percent}%` }}
        />
      </div>

      {/* 🔢 عدد التقييمات */}
      <span className="text-sm w-6 text-right text-gray-600">
        {stats.counts[star]}
      </span>

    </div>
  );
})}
            </div>

            <h4 className="text-[#777777] text-[14px] font-[cairo] pb-4"> التعليقات ({filledCommentReviews.length}) </h4>

            {/* ⭐ التعليقات */}
            <div className="space-y-3">
                {filledCommentReviews.map((review) => (
                    <div
                        key={review.id}
                        className="bg-white p-3 rounded-[4px] shadow flex gap-3"
                    >
                        <img
                            src={`${base_url}/${review.user.profile_image_url}`}
                            alt=""
                            className="w-12 h-12 rounded-full object-cover"
                        />

                        <div className="flex-1">
                            <div className="flex justify-between items-center">
                                <h3 className="font-bold text-sm font-[cairo]">
                                    {review.user.full_name}
                                </h3>

                                <span className="text-xs text-gray-400">
                                    {new Date(review.created_at).toLocaleDateString()}
                                </span>
                            </div>

                            {/* ⭐ النجوم */}
                            <div className="flex mt-1">
                                {[1, 2, 3, 4, 5].map((i) => (
                                    <Icon
                                        key={i}
                                        name="Star"
                                        size={14}
                                        className={
                                            i <= Math.round(getReviewAverage(review))
                                                ? "text-orange-500"
                                                : "text-gray-300"
                                        }
                                    />
                                ))}
                            </div>

                            {/* ⭐ الكومنت */}
                            <p className="text-sm text-gray-600 mt-2 whitespace-pre-line">
                                {review.comment}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReviewsPage;